import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { wagonTypesData, } from './wagonTypeActions'
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

type WagonTypeState = {
  dataWagonTypes: {
    payload: WagonTypeResponse[] | null,
    payload_update: WagonTypeResponse | null,
    loading: boolean,
    success: boolean,
    error: string | null;
  }
}

const initialState:  WagonTypeState= {
  dataWagonTypes: {
    loading: false,
    success: false,
    payload_update: null,
    payload: [],
    error: "",
  }
}

export type WagonTypeResponse = {
  type: string,
  title: string
}

const wagonTypesReducer = createSlice({
  name: 'wagontype',
  initialState: initialState,
  reducers: {

    // Обычные редьюсеры
    setClientsState(state, action: PayloadAction<WagonTypeResponse[]>) {
      state.dataWagonTypes.payload = [];
      state.dataWagonTypes.payload = action.payload;
    },

    setClientUpdateState(state, action: PayloadAction<WagonTypeResponse>) {
      state.dataWagonTypes.payload_update = null;
      state.dataWagonTypes.payload_update = action.payload;
      console.log(state.dataWagonTypes.payload_update)

    }

  },

  extraReducers: (builder) => {
    builder
      .addCase(wagonTypesData.pending, (state) => {
        state.dataWagonTypes.loading = true;
        state.dataWagonTypes.error = null;
      })
      .addCase(wagonTypesData.fulfilled, (state, action) => {
        state.dataWagonTypes.loading = false;
        wagonTypesReducer.caseReducers.setClientsState(state, action);
      })
      .addCase(wagonTypesData.rejected, (state, action) => {
        state.dataWagonTypes.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataWagonTypes.error = errorText ? errorText : "";
      })

  }

})

const getErrorText = (error: ErrorResponse) => {

  console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
}


export default wagonTypesReducer.reducer